import React, { useEffect, useState } from 'react';
import {
  GlobalHeader,
  getRehydratableName,
  getClassNameFactory,
} from '@dcl/ui/';
import './index.css';
import { ILanguageSelectorProps } from './types';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import {
  getLanguageCodes,
  redirectLanguageUrl,
  searchLanguageInfo,
} from './Utils';

export const LanguageSelector: React.FC<ILanguageSelectorProps> = (props) => {
  const { languageInfo } = props;
  const [languageCodes, setLanguageCodes] = useState<string[]>([]);

  useEffect(() => {
    const codes = getLanguageCodes(languageInfo);
    setLanguageCodes(codes);
  }, [languageInfo]);

  const languageOnChangeFun = (locale: string) => {
    const URL = redirectLanguageUrl(languageInfo, locale);
    window.location.href = `${URL}`;
  };

  const selectLanguage = (locale: string, field: string) => {
    return searchLanguageInfo({ languageInfo, locale, field });
  };

  const getClassName = getClassNameFactory(LanguageSelector.displayName);

  return (
    <div
      data-rehydratable={getRehydratableName(LanguageSelector.displayName)}
      {...propsToDataAttributes(props)}
    >
      <div
        className={getClassName({ descendantName: 'main' })}
        data-testid="GlobalHeaderBaseItem-link"
      >
        <GlobalHeader
          leftItems={
            <GlobalHeader.LanguageSelector
              getLanguageName={(locale: string) =>
                selectLanguage(locale, 'language')
              }
              getCountryCode={(locale: string) =>
                selectLanguage(locale, 'country')
              }
              onSelectionChange={(e: string) => {
                languageOnChangeFun(e);
              }}
              getCountryName={(locale: string) => {
                selectLanguage(locale, '');
              }}
              iconAltText={'Change language'}
              supportedLocales={languageCodes}
              currentLocale={languageInfo[0].languageCode}
            />
          }
        />
      </div>
    </div>
  );
};

LanguageSelector.displayName = 'LanguageSelector';
